import CircularProgress from '@material-ui/core/CircularProgress';
import * as React from 'react';
import { CustomAttributeParser, HtmlTypeAttribute } from "../../common";
import { StyledButton, StyledFlatButton, StyledFlatCompactButton, StyledIconButton, StyledLeftIcon, StyledRightIcon, StyledSearchButton, StyledSpinner, StyledTransparentBlueButton, StyledTransparentWhiteButton } from './button.style';
export var ButtonStyle;
(function (ButtonStyle) {
    ButtonStyle["Primary"] = "mi-btn-primary";
    ButtonStyle["Secondary"] = "mi-btn-secondary";
    ButtonStyle["Tertiary"] = "mi-btn-tertiary";
    ButtonStyle["Suggested"] = "mi-btn-suggested";
    ButtonStyle["Flat"] = "mi-btn-flat";
    ButtonStyle["FlatCompact"] = "mi-btn-flat-compact";
    ButtonStyle["Search"] = "mi-btn-search";
    ButtonStyle["TransparentWhite"] = "mi-btn-transparent-white";
    ButtonStyle["TransparentBlue"] = "mi-btn-transparent-blue";
})(ButtonStyle || (ButtonStyle = {}));
export const BASE_SEARCH_BUTTON_ID = 'mi-search-button';
export const Button = (props) => {
    const isFlat = props.style === ButtonStyle.Flat;
    let DesiredButton = StyledButton;
    let DesiredIconButton = StyledIconButton;
    let icon = props.icon;
    let id = props.id;
    switch (props.style) {
        case ButtonStyle.Search:
            icon = 'mi-icon-search';
            id = props.id || BASE_SEARCH_BUTTON_ID;
            DesiredIconButton = StyledSearchButton;
            break;
        case ButtonStyle.Flat:
            DesiredButton = StyledFlatButton;
            break;
        case ButtonStyle.FlatCompact:
            DesiredButton = StyledFlatCompactButton;
            break;
        case ButtonStyle.TransparentWhite:
            DesiredButton = StyledTransparentWhiteButton;
            break;
        case ButtonStyle.TransparentBlue:
            DesiredButton = StyledTransparentBlueButton;
            break;
        default:
            break;
    }
    return props.label != null ? (
    // show button with text, optionally decorated with icons on left/right side
    React.createElement(DesiredButton, Object.assign({ isBusy: props.isBusy, icon: icon, iconRight: props.iconRight, className: `${props.className} ${props.style}`, onClick: props.onClick, disabled: props.disabled || props.isBusy, showPointer: props.disabled || props.isBusy, isHoverEffectDisabled: props.isHoverEffectDisabled, type: props.type, id: id, "aria-label": props.ariaLabel }, CustomAttributeParser(props.customAttributes)),
        props.isBusy ? (React.createElement(StyledSpinner, { isFlat: isFlat },
            React.createElement(CircularProgress, { size: 16, color: 'inherit' }))) : (React.createElement(StyledLeftIcon, { isFlat: isFlat, id: `${id}_styled_left_icon`, className: props.icon, iconName: props.icon })),
        props.label,
        React.createElement(StyledRightIcon, { id: `${id}_styled_right_icon`, isFlat: isFlat, className: props.iconRight }))) : (
    // show icon button only, activated by passing props.label == undefined
    React.createElement(DesiredIconButton, Object.assign({ onClick: e => {
            !props.disabled && props.onClick && props.onClick(e);
        }, type: props.type, className: `${icon} ${props.className}`, padding: props.padding, fontSize: props.iconSize, disabled: props.disabled }, CustomAttributeParser(props.customAttributes), { id: id, "aria-label": props.ariaLabel })));
};
Button.defaultProps = {
    isBusy: false,
    icon: '',
    iconRight: '',
    iconSize: 20,
    style: ButtonStyle.Primary,
    className: '',
    disabled: false,
    type: HtmlTypeAttribute.BUTTON,
    isHoverEffectDisabled: false
};
//# sourceMappingURL=Button.js.map